export default __webpack_public_path__ + "static/media/2239.49dbde44.png";